<template>
  <div class="content">
     <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
      <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>物资管理</el-breadcrumb-item>
            <el-breadcrumb-item>入库记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="content-container">
      <div class="search">
        <div style="display: flex;">
          <el-input v-model="search.orderNumber" placeholder="请输入订单编号" size="small" clearable style="width: 10vw;"></el-input>
          <el-date-picker v-model="search.time" type="date" @change="changeTime" placeholder="选择日期" size="small" value-format="yyyy-MM-dd" clearable style="width: 10vw;margin: 0 1vw;"></el-date-picker>
          <el-button size="small" type="primary" @click="select">查询</el-button>
        </div>
        <!-- <el-button size="small" type="primary">导出表单</el-button> -->
      </div>
      <div class="main">
        <div class="title">入库详情</div>
        <el-table stripe :data="tableData" height="68vh">
          <el-table-column label="序号" width="80">
            <template slot-scope="scope"> 
                <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号">
            <template slot-scope="scope"> 
                <span>{{ scope.row.orderNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="材料类型">
            <template slot-scope="scope"> 
                <span>{{ getMaterialType(scope.row.material_type) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="材料名称">
            <template slot-scope="scope"> 
                <span>{{ scope.row.materialName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="材料型号">
            <template slot-scope="scope"> 
                <span>{{ scope.row.materialModel }}</span>
            </template>
          </el-table-column>
          <el-table-column label="材料品牌">
            <template slot-scope="scope"> 
                <span>{{ scope.row.materialBrand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总金额（元）">
            <template slot-scope="scope"> 
                <span>{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出库数量">
            <template slot-scope="scope"> 
                <span>{{ scope.row.amount }}{{ scope.row.materialUnitTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="生产厂家">
            <template slot-scope="scope"> 
                <span>{{ scope.row.materialManufacturer }}</span>
            </template>
          </el-table-column>
          <el-table-column label="供应商">
            <template slot-scope="scope"> 
                <span>{{ scope.row.materialSupplier }}</span>
            </template>
          </el-table-column>
          <el-table-column label="入库时间">
            <template slot-scope="scope"> 
                <span>{{ scope.row.createDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="入库人">
            <template slot-scope="scope"> 
                <span>{{ scope.row.crerateName }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  export default {
    data() {
      return {
        projectId: '',
        search: {
          orderNumber: '',
          time: ''
        },
        typeList: [],
        tableData: [],
        pageSize: 20,
        pageNum: 1,
        total: 0
      }
    },
    created(){
      this.projectId = util.session.get('groupId')
      this.getData()
      this.getType()
    },
    methods: {
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      changeTime(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      // 获取数据
      getData(){
        myHttp.findProjectSupplierStorageRecordPage({
          projectId: this.projectId,
          orderNumber: this.search.orderNumber,
          time: this.search.time,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.projectSupplierStorageRecordPage.list || []
            list.forEach((item, index) => {
              item.index = (this.pageNum - 1) * this.pageSize + 1 + index
            })
            this.tableData = list
            this.total = resp.data.data.projectSupplierStorageRecordPage.total
          }
        })
      },
      //  获取材料类型
      getType(){
        myHttp.getDictByType({
          type: 'material_type'
        }).then(resp => {
           if(resp.data.code === 200){
             this.typeList = resp.data.data.dictList || []
           }else{
             this.$message.error(resp.data.msg)
           }
        })
      },
      getMaterialType(type){
        for(let i=0;i<this.typeList.length;i++){
          if(type == this.typeList[i].value){
            return this.typeList[i].label
          }
        }
      }
    },
  }
</script>

<style scoped>
.content-container{
  width: 100%;
  height: calc(100% - 10px);
  background-color: #fff;
  border-radius: 6px;
  padding-top: 1vh;
}
.search{
  display: flex;
  padding: 0 1vw;
  justify-content: space-between;
}
.title{
  width: 100%;
  height: 60px;
  color: #333;
  font-weight: 900;
  background-color: #E6E6E6;
  margin-top: 1vh;
  line-height: 60px;
  font-size: 1.2vw;
  letter-spacing: 8px;
}
.el-pagination{
  background-color: #E6E6E6;
  padding: 10px 0!important;
  border-radius: 0 0 6px 6px;
}
</style>